import ErrorComponent from "./ErrorComponent";
import SuccessComponent from "./SuccessComponent";

// eslint-disable-next-line
export default {
  SuccessComponent,
  ErrorComponent,
};
